var _defs, _path, _path2, _path3, _path4, _path5, _ellipse, _ellipse2, _ellipse3, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefitOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 198.43 198.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_566f338511ce0ca9b51ab022fd913a7ac6c4c21fcdb39a9ff48e179f7d287ac0",
    x1: 142.13,
    y1: 39.61,
    x2: 176.27,
    y2: 39.61,
    gradientTransform: "rotate(-.6 8727.831 2079.737)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a0399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b10372"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_566f338511ce0ca9b51ab022fd913a7ac6c4c21fcdb39a9ff48e179f7d287ac0",
    "data-name": "C_BG_shellbar",
    x1: 75.15,
    y1: 27.98,
    x2: 117.41,
    y2: 27.98,
    xlinkHref: "#SVGID_0_566f338511ce0ca9b51ab022fd913a7ac6c4c21fcdb39a9ff48e179f7d287ac0"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_566f338511ce0ca9b51ab022fd913a7ac6c4c21fcdb39a9ff48e179f7d287ac0",
    "data-name": "C_BG_shellbar",
    x1: 76.15,
    y1: 40.98,
    x2: 118.41,
    y2: 40.98,
    gradientTransform: "translate(-1 -13)",
    xlinkHref: "#SVGID_0_566f338511ce0ca9b51ab022fd913a7ac6c4c21fcdb39a9ff48e179f7d287ac0"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_566f338511ce0ca9b51ab022fd913a7ac6c4c21fcdb39a9ff48e179f7d287ac0",
    "data-name": "C_BG_shellbar",
    x1: 84.72,
    y1: 69.98,
    x2: 109.29,
    y2: 69.98,
    xlinkHref: "#SVGID_0_566f338511ce0ca9b51ab022fd913a7ac6c4c21fcdb39a9ff48e179f7d287ac0"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_566f338511ce0ca9b51ab022fd913a7ac6c4c21fcdb39a9ff48e179f7d287ac0",
    "data-name": "C_BG_shellbar",
    x1: 109.86,
    y1: 39.12,
    x2: 148.03,
    y2: 39.12,
    xlinkHref: "#SVGID_0_566f338511ce0ca9b51ab022fd913a7ac6c4c21fcdb39a9ff48e179f7d287ac0"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_566f338511ce0ca9b51ab022fd913a7ac6c4c21fcdb39a9ff48e179f7d287ac0",
    "data-name": "C_BG_shellbar",
    x1: 103.93,
    y1: 101.21,
    x2: 142.08,
    y2: 101.21,
    xlinkHref: "#SVGID_0_566f338511ce0ca9b51ab022fd913a7ac6c4c21fcdb39a9ff48e179f7d287ac0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M122.78 92.02l.01 2.94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M90.03 130.85H61.71c-2.31 0-4.19-2.08-4.19-4.64V30.55c0-2.56 1.88-4.64 4.19-4.64h15.42M115.26 25.91h15.59c2.31 0 4.19 2.08 4.19 4.64v57.08"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_1_566f338511ce0ca9b51ab022fd913a7ac6c4c21fcdb39a9ff48e179f7d287ac0)",
    d: "M112.25 33.61l4.06-11.27H76.25l4.06 11.27h31.94z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_3_566f338511ce0ca9b51ab022fd913a7ac6c4c21fcdb39a9ff48e179f7d287ac0)",
    d: "M112.25 33.61l4.06-11.27H76.25l4.06 11.27h31.94z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M107.01 69.52a8.18 8.18 0 017.57-5.08c3.86 0 7.09 2.68 7.95 6.28M70.03 70.84c.81-3.66 4.07-6.4 7.98-6.4 4.23 0 7.7 3.21 8.13 7.33"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "MI_4L_main",
    cx: 114.78,
    cy: 59.78,
    rx: 4.75,
    ry: 4.67
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "MI_4L_main",
    cx: 97.18,
    cy: 57.41,
    rx: 6.71,
    ry: 6.6
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "MI_4L_main",
    cx: 78.02,
    cy: 59.78,
    rx: 4.75,
    ry: 4.67
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M85.16 75.36C85.73 69.32 90.82 64.6 97 64.6s11.22 4.68 11.83 10.67",
    stroke: "url(#SVGID_3_566f338511ce0ca9b51ab022fd913a7ac6c4c21fcdb39a9ff48e179f7d287ac0)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M85.16 75.36C85.73 69.32 90.82 64.6 97 64.6s11.22 4.68 11.83 10.67"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M136.75 124.78s-.02.03-.04.04c-1.97-1.97-5.15-2.99-7.12-1.03a5.028 5.028 0 000 7.12l7.12 7.12 7.12-7.12s.03-.02.04-.04a5.028 5.028 0 000-7.12c-1.97-1.97-5.15-.94-7.12 1.03z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M137.23 112.08c9.29.26 16.8 7.83 16.89 17.21s-7.61 17.48-17.22 17.58c-5.89.06-11.13-2.81-14.32-7.26",
    stroke: "url(#SVGID_0_566f338511ce0ca9b51ab022fd913a7ac6c4c21fcdb39a9ff48e179f7d287ac0)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M122.71 119.13c1.96 2.83 3.13 6.26 3.17 9.96.1 9.85-7.8 17.92-17.65 18.02-9.85.1-17.92-7.8-18.02-17.65-.1-9.85 7.8-17.92 17.65-18.02",
    stroke: "url(#SVGID_4_566f338511ce0ca9b51ab022fd913a7ac6c4c21fcdb39a9ff48e179f7d287ac0)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M126.16 98.41s-.6-3.45-3.46-3.45-3.62 3.46-3.62 3.46l7.43 5.62"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M119.43 104.04s.6 3.45 3.46 3.45 3.62-3.46 3.62-3.46M122.8 107.49v2.95M108.04 121.45l2.55 5.16 5.69.82-4.12 4.02.98 5.67-5.1-2.68-5.09 2.68.97-5.67-4.12-4.02 5.7-.82 2.54-5.16z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5 MI_4L_gradient",
    cx: 123,
    cy: 101.21,
    r: 17.82,
    stroke: "url(#SVGID_5_566f338511ce0ca9b51ab022fd913a7ac6c4c21fcdb39a9ff48e179f7d287ac0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitOverview);
export default __webpack_public_path__ + "static/media/benefitOverview.16dbe640825b3dc78ffb8273a18bef9b.svg";
export { ForwardRef as ReactComponent };